// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_uz-8";
export var editMode = "_uz-3";
export var headerRow = "_uz-a";
export var headerTitle = "_uz-b";
export var product = "_uz-1";
export var productDetails = "_uz-5";
export var productDivider = "_uz-7";
export var productImage = "_uz-2";
export var productInfo = "_uz-4";
export var productTitle = "_uz-6";
export var strikethrough = "_uz-9";
export var upsellProductsCard = "_uz-0";